import { useEffect, useState } from 'react';
import type { Menu, SubMenu } from 'types/capi/plp';

import MenuOptionsListItem from './MenuOptionsListItem';
import Search from './Search';

type Props = {
  menu: Menu | SubMenu;
  onOptionSelect: (value: string) => void;
};

function containsText(text: string, query: string) {
  return text.toLowerCase().includes(query.toLowerCase());
}

export default function MenuOptionsList({
  menu,
  onOptionSelect = () => {}
}: Props) {
  const [items, setItems] = useState(menu.items);
  const [query, setQuery] = useState('');

  useEffect(() => {
    const filteredItems = menu.items?.filter((i) =>
      containsText(i.text, query)
    );

    setItems(filteredItems);
  }, [menu.items, query]);

  const shouldShowSearch = menu.items.length > 7;

  return (
    <>
      {shouldShowSearch && (
        <div className="flex items-center justify-center bg-concrete p-4 md:px-4">
          <Search value={query} onChange={(e) => setQuery(e.target.value)} />
        </div>
      )}
      {items?.map((item, index) => (
        <MenuOptionsListItem
          menuId={menu.id}
          item={item}
          key={`${item.path}-${index}`}
          onSelect={onOptionSelect}
        />
      ))}
    </>
  );
}
